import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { CSOB_SK_CONFIG } from "./config";

import WelcomeBannerContainer from "@components/main/co2/hub/WelcomeBanner";
import CollectData from "@components/main/co2/hub/CollectData";
import Reports from "@components/main/co2/hub/Reports";
import { Box, Grid } from "@components/base";

const CsobSkHubPage: FC = () => {
  const { t } = useTranslation();

  return (
    <Box mb={6}>
      <Grid container spacing={3}>
        <WelcomeBannerContainer
          title={t(CSOB_SK_CONFIG.welcomeBanner.titleKey)}
          text={t(CSOB_SK_CONFIG.welcomeBanner.textKey)}
          color={CSOB_SK_CONFIG.welcomeBanner.color}
          icon={CSOB_SK_CONFIG.welcomeBanner.icon}
        />
        <Grid size={12}>
          <CollectData
            formBaseType={CSOB_SK_CONFIG.formBaseType}
            titleKey={t(CSOB_SK_CONFIG.collectData.titleKey)}
            descriptionKey={t(CSOB_SK_CONFIG.collectData.descriptionKey)}
            color={CSOB_SK_CONFIG.collectData.color}
            icon={CSOB_SK_CONFIG.collectData.icon}
            buttonTextKey={t(CSOB_SK_CONFIG.collectData.buttonTextKey)}
            noFormsTextKey={t(CSOB_SK_CONFIG.collectData.noFormsTextKey)}
          />
        </Grid>
        <Grid size={12}>
          <Reports
            formBaseType={CSOB_SK_CONFIG.formBaseType}
            title={t(CSOB_SK_CONFIG.reports.titleKey)}
            type={CSOB_SK_CONFIG.reports.type}
            noReportsText={t(CSOB_SK_CONFIG.reports.noReportsTextKey)}
            fillFormText={t(CSOB_SK_CONFIG.reports.fillFormTextKey)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CsobSkHubPage;
